module.exports = {"451322100":"象州镇","451322101":"石龙镇","451322102":"运江镇","451322103":"寺村镇","451322104":"中平镇","451322105":"罗秀镇","451322106":"大乐镇","451322107":"马坪镇","451322201":"妙皇乡","451322202":"百丈乡","451322203":"水晶乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/451322.json
// module id = 1996
// module chunks = 0